/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-03-29 14:10:36
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbPickupOrder {
    /**
     * 获取提货单列表
     */
    export var GetTbPickupOrderList = (body:any): Promise<any> => {
        return Get(`/api/TbPickupOrder/GetTbPickupOrderList`, body);
    };
    /**
     * 获取提货商品列表
     */
    export var GetTbPickupOrderItemList = (body:any): Promise<any> => {
        return Get(`/api/TbPickupOrder/GetTbPickupOrderItemList`, body);
    };
    /**
     * 获取提货商品统计列表
     */
    export var GetTbPickupOrderReportList = (body:any): Promise<any> => {
        return Get(`/api/TbPickupOrder/GetTbPickupOrderReportList`, body);
    };
}



// WEBPACK FOOTER //
// ./src/http/api_TbPickupOrder.ts